<template>
  <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
    <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Name
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              <el-tooltip
                effect="dark"
                :content="`To test the ${type.toLowerCase()}, send header X-${type}-Code: XXX and X-Lang: fr`"
                placement="top"
              >
                <span class="cursor-pointer">Code (?)</span>
              </el-tooltip>
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Status
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Who
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              Where
            </th>
            <th
              v-if="type === 'Waves' || type === 'Banners'"
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              When
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
            >
              <span>stats</span>
            </th>
            <th
              class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">{{ item.name }}</p>
              <p class="text-xs">{{ new Date(item.datecreation).toLocaleDateString('fr') }}</p>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <div class="fields-container">
                <div class="relative">
                  <button
                    class="rounded bg-gray-200 button-field font-semibold"
                    v-on:click="
                      e => {
                        copyFieldToClipBoard(e, item.code)
                      }
                    "
                  >
                    {{ item.code }}
                  </button>
                  <div class="copy-popin">Copied !</div>
                </div>
              </div>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <span
                class="relative inline-block px-3 py-1 font-semibold leading-tight"
                :class="{
                  'text-green-900':
                    item.status === 'enable' || item.status === 'pending' || item.status === 'terminated',
                  'text-gray-900': item.status === 'disable'
                }"
              >
                <span
                  aria-hidden
                  class="absolute inset-0 opacity-50 rounded"
                  :class="{
                    'bg-green-200':
                      item.status === 'enable' || item.status === 'pending' || item.status === 'terminated',
                    'bg-gray-200': item.status === 'disable'
                  }"
                ></span>
                <span class="relative">
                  <template v-if="item.status === 'enable'">Enable</template>
                  <template v-else-if="item.status === 'pending'">Pending</template>
                  <template v-else-if="item.status === 'terminated'">Terminated</template>
                  <template v-else>Disable</template>
                </span>
              </span>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">{{ item.target_audience }}</p>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
              <p class="text-gray-900 whitespace-no-wrap">
                <template v-if="item.url_target_list.includes('.*')">Every where on <br />{{ item.url }}</template>
                <template v-else>
                  <span :key="index" class="relative inline-block px-3 py-1 text-gray-900 leading-tight">
                    <span aria-hidden class="absolute inset-0 bg-gray-200 opacity-50 rounded mr-2"></span>
                    <span class="relative">{{ item.url_target_string }}</span>
                  </span>
                  on <br />{{ item.url }}</template
                >
              </p>
            </td>

            <td
              v-if="type === 'Waves' || type === 'Banners'"
              class="px-5 py-5 border-b border-gray-200 bg-white text-sm"
            >
              <p class="text-gray-900 whitespace-no-wrap">
                <span v-if="item.frequencylimitation === 'none' && item.frequencylimitationvalue === 1"
                  >Show every time</span
                >
                <span v-if="item.frequencylimitation === 'none' && item.frequencylimitationvalue === 0"
                  >Only manually</span
                >
                <span v-if="item.frequencylimitation !== 'none' && item.frequencylimitationvalue > 0"
                  >Show {{ item.frequencylimitationvalue }} times per {{ item.frequencylimitation }}</span
                >
                <span v-if="item.frequencylimitation !== 'none' && item.frequencylimitationvalue === 0"
                  >Can't show</span
                >

                <span v-if="item.activationdate && item.deactivationdate"
                  >between {{ _getDate(item.activationdate, site.timezone) | date }} and
                  {{ _getDate(item.deactivationdate, site.timezone) | date }}</span
                >
              </p>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-center">
              <p class="text-gray-900 whitespace-no-wrap flex justify-center items-center">
                <button class="flex items-center gap-1" v-on:click="handleStatsClick(item.id)">
                  <span class=" bg-gray-200 rounded p-2">
                    <svg
                      class="text-gray-600 fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                    >
                      <path d="M192-192v-384h144v384H192Zm216 0v-576h144v576H408Zm216 0v-288h144v288H624Z" />
                    </svg>
                  </span>
                </button>
                <button v-if="false" class="flex items-center gap-1" v-on:click="handleCommentsClick(item.id)">
                  Comments
                </button>
              </p>
            </td>

            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
              <router-link
                class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2"
                :to="{ name: 'Survey', params: { site: site.sitekey, id: item.id } }"
              >
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </router-link>
              <a class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2" @click="onDuplicate(item.id)">
                <font-awesome-icon icon="clone"></font-awesome-icon>
              </a>
              <a @click="onDelete(item)" class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2">
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TableTargetContent',

  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },

  methods: {
    copyFieldToClipBoard(e, field) {
      navigator.clipboard.writeText(field)
      e.target.classList.add('active')
      setTimeout(() => {
        e.target.classList.remove('active')
      }, 1000)
    },

    handleStatsClick(id) {
      this.$emit('on-stats-click', id)
    },

    handleCommentsClick(id) {
      this.$emit('on-comments-click', id)
    },

    onDuplicate(id) {
      this.$emit('on-duplicate', id)
    }
  }
}
</script>

<style>
.fields-container {
  display: flex;
  gap: 10px 16px;
  flex-flow: row wrap;
}

.button-field {
  padding: 4px 8px;
}

.copy-popin {
  display: none;
  z-index: 10;
  position: absolute;
  top: -36px;
  left: 50%;
  width: 70px;
  box-sizing: border-box;
  margin-left: -35px;
  padding: 4px 8px;
  text-align: center;
  border-radius: 0.25rem;
  background-color: #f59e0b;
  color: #fff;
}

.button-field.active ~ .copy-popin {
  display: block;
  animation: 1s linear pop;
  transform: scale(0);
}

@keyframes pop {
  from {
    transform: scale(0.5);
  }
  10% {
    transform: scale(1);
  }
  90% {
    transform: scale(1);
  }
  to {
    transform: scale(0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/ui/table-targeted-content.vue